// extracted by mini-css-extract-plugin
module.exports = {"credits":"credits_credits__q8goG","back-navigation":"credits_back-navigation__3vqCi","container":"credits_container__aEfQt"};